var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-carousel',{attrs:{"autoplay":""}},_vm._l((_vm.ListInstance),function(url){return _c('img',{key:url,staticClass:"infosImg",attrs:{"src":url,"alt":"轮播图片"}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }